const headerDataTransformer = (headerData)=>{
    if (!headerData) {
        return {};
    }
    const { contactSalesLink, loginLink, dashboardButton, signupButton, menu = [], banner } = headerData;
    return {
        skipLinkLabel: 'Primary Navigation',
        banner: banner,
        metaMenuLinks: {
            contactSalesLink: {
                id: '0',
                label: contactSalesLink?.title || '',
                href: contactSalesLink?.path || ''
            },
            dashboardLink: {
                id: '1',
                label: dashboardButton?.title || '',
                href: dashboardButton?.path || ''
            },
            loginLink: {
                id: '2',
                label: loginLink?.title || '',
                href: loginLink?.path || ''
            },
            signupLink: {
                id: '3',
                label: signupButton?.title || '',
                href: signupButton?.path || ''
            }
        },
        menu: {
            id: '0',
            label: 'Menu',
            children: menu.filter((child)=>child?.title).map((child, childIndex)=>{
                return {
                    id: childIndex.toString(),
                    label: child.title,
                    href: child?.path,
                    children: child?.groups?.map((grandChild, grandChildIndex)=>{
                        return {
                            id: grandChildIndex.toString(),
                            label: grandChild?.title,
                            children: grandChild?.items?.map((greatGrandChild, greatGrandChildIndex)=>{
                                return {
                                    id: greatGrandChildIndex.toString(),
                                    label: greatGrandChild.title,
                                    href: greatGrandChild?.path,
                                    media: greatGrandChild?.image ? {
                                        url: greatGrandChild?.image?.src,
                                        width: greatGrandChild?.image?.width,
                                        height: greatGrandChild?.image?.height,
                                        title: greatGrandChild?.title
                                    } : undefined
                                };
                            })
                        };
                    })
                };
            })
        }
    };
};

export { headerDataTransformer };
